import {
  createFilterFormStore,
  usePersistedFilterFormik,
} from "../../../util/usePersistedFilterFormik";
import { useEffect } from "react";
import { convertToFilter, makeObservable } from "../../../util";
import { createSearchResultNavigationStore } from "../../../util/searchResultNavigation";

// observable store
const consignmentFilterStore = makeObservable({});
const consignmentNavigationStore = createSearchResultNavigationStore(
  consignmentFilterStore,
);

const toConsignmentFilter = values =>
  convertToFilter({
    values,
    filterKeys: ["tab"],
    skipKeys: ["limit", "offset"],
  });

const filterFormStore = createFilterFormStore(
  "consignment",
  consignmentFilterStore,
  consignmentNavigationStore,
  { toFilter: toConsignmentFilter },
);

const useConsignmentFilters = () => {
  const formik = usePersistedFilterFormik(
    {
      initialValues: {
        limit: 50,
        offset: 0,
        sort1: { operator: "ASC" },
        sort2: { operator: "ASC" },
        sort3: { operator: "ASC" },
        tab: "artworks",
        _contact: { typeId: { operator: "in" } },
      },
    },
    filterFormStore,
  );

  useEffect(() => {
    // convert formik values to filter and update store
    consignmentFilterStore.set(toConsignmentFilter(formik.values));
  }, [formik.values]);

  return {
    formik,
  };
};

export {
  consignmentFilterStore,
  consignmentNavigationStore,
  useConsignmentFilters,
};
